import { Field, Form, Formik, FormikHelpers } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Container, Row } from "reactstrap";
import * as Yup from "yup";
import { useGetAllModelTypesList } from "../ModelTypes/api/getAllModelTypesList";


const ModelForm = ({ type, initialValues, onSubmit }: ModelFormProps) => {
    const { t } = useTranslation();
    const getAllModelTypesQuery = useGetAllModelTypesList();

    const validationSchema= Yup.object({
      description: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
      modelTypeID: Yup.string().required('Το πεδίο είναι υποχρεωτικό'),
    })

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values, formikHelpers) => {
          if (type === "create") {
            onSubmit(values, formikHelpers);
          } else {
            onSubmit(
              values, formikHelpers
            );
          }
        }}
        validationSchema={validationSchema}
      >
        {({ errors, touched, isSubmitting, values, getFieldProps }) => (
          <Form>
            <Container fluid className="p-0">
              <Row>

                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Τύπος Συσκευής")}*`}
                  </label>
                  <Field
                    name="description"
                    className="form-control"
                    placeholder=""
                    type="text"
                    field="description" 
                  />
                  <div className="text-danger">
                    {errors.description && touched.description && (
                      <div>{errors.description}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Είδος Συσκευής")}*`}
                  </label>
                  <Field
                  as="select"
                  name="modelTypeID"
                  className="form-control"
                  placeholder=""
                  type="text"
                  field="modelTypeID"
                >
                  <option value="">{t("Επιλέξτε Είδος Συσκευής")}</option>
                  {getAllModelTypesQuery.data &&
                    getAllModelTypesQuery.data.map((model) => (
                      <option key={model.id} value={model.id}>
                        {model.description}
                      </option>
                    ))}
                </Field>
                  <div className="text-danger">
                    {errors.modelTypeID && touched.modelTypeID && (
                      <div>{errors.modelTypeID}</div>
                    )}
                  </div>
                </Col>
                <Col xs={6}>
                  <label className="form-label">
                    {`${t("Είναι Module")}*`}
                  </label>
                  <Field
                    type="checkbox"
                    name="module"
                    field="module"
                  />
                  <div className="text-danger">
                    {errors.module && touched.module && (
                      <div>{errors.module}</div>
                    )}
                  </div>
                </Col>
            
              </Row>
            </Container>

            <div className="mb-3">
              <Button
                type="submit"
                size="sm"
                styletype="primary"
                disabled={isSubmitting}
              >
                {type == "create" ? t("Δημιουργία") : t("Αποθήκευση")}
              </Button>
            </div>
          </Form>
      )}
      </Formik>
  )
}

export default ModelForm;

type CreateOrEdit =
  | {
      type: "create";
      initialValues: ICreateModelForm;
      onSubmit: (
        values: ICreateModelForm,
        formikHelpers: FormikHelpers<ICreateModelForm>
      ) => void;
    }
  | {
      type: "edit";
      initialValues: IEditModelForm;
      onSubmit: (
        values: IEditModelForm,
        formikHelpers: FormikHelpers<IEditModelForm>
      ) => void;
    };

type ModelFormProps = CreateOrEdit;